var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "add-new-vp" }, [
    _c("div", { staticClass: "add-new-vp-header" }, [
      _c("div", { staticClass: "d-flex align-items-center" }, [
        _vm.typeSelected === "form"
          ? _c("img", {
              staticClass: "icon-new-vp",
              attrs: { src: require("@/assets/automation/data_manager.svg") }
            })
          : _vm.typeSelected === "event"
          ? _c("img", {
              staticClass: "icon-new-vp",
              attrs: { src: require("@/assets/automation/event.svg") }
            })
          : _vm.typeSelected === "function"
          ? _c("img", {
              staticClass: "icon-new-vp",
              attrs: { src: require("@/assets/automation/function.svg") }
            })
          : _vm.typeSelected === "job" || _vm.typeSelected === "dedicated_job"
          ? _c("img", {
              staticClass: "icon-new-vp",
              attrs: { src: require("@/assets/automation/job.svg") }
            })
          : _c("img", {
              staticClass: "icon-new-vp",
              attrs: { src: require("@/assets/automation/api.svg") }
            }),
        _vm._v(" "),
        _c("h4", { staticClass: "title-modal-add-vp" }, [
          _vm._v(_vm._s(_vm.titleHeader))
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "close-modal", on: { click: _vm.closeModal } }, [
        _vm._v("\n      ×\n    ")
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "add-new-vp-content" },
      [
        _c(
          "b-form-group",
          {
            staticClass: "mb-2",
            class: { "error-input": _vm.$v.dataAutomation.name.$error }
          },
          [
            _c("label", { attrs: { for: "name" } }, [_vm._v(" Name ")]),
            _vm._v(" "),
            _c("j-input", {
              attrs: {
                id: "name",
                "error-required": _vm.$v.dataAutomation.name.$error,
                placeholder: "Enter name here"
              },
              model: {
                value: _vm.$v.dataAutomation.name.$model,
                callback: function($$v) {
                  _vm.$set(_vm.$v.dataAutomation.name, "$model", $$v)
                },
                expression: "$v.dataAutomation.name.$model"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-form-group",
          {
            staticClass: "mb-2",
            class: { "error-input": _vm.$v.dataAutomation.description.$error }
          },
          [
            _c("label", { attrs: { for: "description" } }, [
              _vm._v(" Description ")
            ]),
            _vm._v(" "),
            _c("j-textarea", {
              attrs: {
                "error-required": _vm.$v.dataAutomation.description.$error,
                "max-length": 255,
                placeholder: "Enter description here"
              },
              model: {
                value: _vm.$v.dataAutomation.description.$model,
                callback: function($$v) {
                  _vm.$set(_vm.$v.dataAutomation.description, "$model", $$v)
                },
                expression: "$v.dataAutomation.description.$model"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.dataAutomation.object === "form"
          ? _c(
              "b-form-group",
              {
                staticClass: "mb-2",
                class: {
                  "error-input": _vm.$v.dataAutomation.table_group.$error
                }
              },
              [
                _c("label", [_vm._v(" Table Group ")]),
                _vm._v(" "),
                _c("j-single-select", {
                  attrs: {
                    "error-required": _vm.$v.dataAutomation.table_group.$error,
                    options: _vm.tableGroupOptions,
                    placeholder: "Select Table Group",
                    "value-format": "object",
                    label: "name"
                  },
                  model: {
                    value: _vm.$v.dataAutomation.table_group.$model,
                    callback: function($$v) {
                      _vm.$set(_vm.$v.dataAutomation.table_group, "$model", $$v)
                    },
                    expression: "$v.dataAutomation.table_group.$model"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.dataAutomation.object === "form"
          ? _c(
              "b-form-group",
              {
                staticClass: "mb-2",
                class: { "error-input": _vm.$v.dataAutomation.form.$error }
              },
              [
                _c("label", [_vm._v(" Table ")]),
                _vm._v(" "),
                _c("j-single-select", {
                  attrs: {
                    "error-required": _vm.$v.dataAutomation.form.$error,
                    disabled: !_vm.dataAutomation.table_group,
                    options: _vm.tableOptions,
                    placeholder: "Select Table",
                    "value-format": "object",
                    label: "name"
                  },
                  model: {
                    value: _vm.$v.dataAutomation.form.$model,
                    callback: function($$v) {
                      _vm.$set(_vm.$v.dataAutomation.form, "$model", $$v)
                    },
                    expression: "$v.dataAutomation.form.$model"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.dataAutomation.object === "form"
          ? _c(
              "b-form-group",
              {
                staticClass: "mb-2",
                class: { "error-input": _vm.$v.dataAutomation.event.$error }
              },
              [
                _c("label", [_vm._v(" Event ")]),
                _vm._v(" "),
                _c("j-single-select", {
                  attrs: {
                    "error-required": _vm.$v.dataAutomation.event.$error,
                    options: _vm.eventOptions,
                    placeholder: "Event"
                  },
                  model: {
                    value: _vm.$v.dataAutomation.event.$model,
                    callback: function($$v) {
                      _vm.$set(_vm.$v.dataAutomation.event, "$model", $$v)
                    },
                    expression: "$v.dataAutomation.event.$model"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.dataAutomation.object === "webhook_v2" ||
        _vm.dataAutomation.object === "api_v2"
          ? _c(
              "b-form-group",
              {
                staticClass: "mb-2",
                class: { "error-input": _vm.$v.dataAutomation.method.$error }
              },
              [
                _c("label", [_vm._v(" Method ")]),
                _vm._v(" "),
                _c("j-single-select", {
                  attrs: {
                    "error-required": _vm.$v.dataAutomation.method.$error,
                    options: _vm.methodOptions,
                    placeholder: "Select"
                  },
                  model: {
                    value: _vm.$v.dataAutomation.method.$model,
                    callback: function($$v) {
                      _vm.$set(_vm.$v.dataAutomation.method, "$model", $$v)
                    },
                    expression: "$v.dataAutomation.method.$model"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.dataAutomation.object === "webhook_v2" ||
        _vm.dataAutomation.object === "api_v2"
          ? _c(
              "b-form-group",
              {
                staticClass: "mb-2",
                class: { "error-input": _vm.$v.dataAutomation.url.$error }
              },
              [
                _c("label", [_vm._v(" Url ")]),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c("b-col", { attrs: { md: "6" } }, [
                      _c("div", { staticClass: "block-url" }, [
                        _vm._v(_vm._s(_vm.url))
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "p__l--1", attrs: { md: "6" } },
                      [
                        _c("j-input", {
                          staticClass: "url-input",
                          staticStyle: { "margin-left": "-35px" },
                          attrs: { "max-length": 255 },
                          model: {
                            value: _vm.$v.dataAutomation.url.$model,
                            callback: function($$v) {
                              _vm.$set(_vm.$v.dataAutomation.url, "$model", $$v)
                            },
                            expression: "$v.dataAutomation.url.$model"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.dataAutomation.object === "event"
          ? _c(
              "b-form-group",
              {
                staticClass: "mb-2",
                class: {
                  "error-input": _vm.$v.dataAutomation.event_name.$error
                }
              },
              [
                _c("label", [_vm._v(" Event Name ")]),
                _vm._v(" "),
                _c("j-single-select", {
                  attrs: {
                    "error-required": _vm.$v.dataAutomation.event_name.$error,
                    options: _vm.optionEventName,
                    placeholder: "Select"
                  },
                  model: {
                    value: _vm.$v.dataAutomation.event_name.$model,
                    callback: function($$v) {
                      _vm.$set(_vm.$v.dataAutomation.event_name, "$model", $$v)
                    },
                    expression: "$v.dataAutomation.event_name.$model"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.dataAutomation.object === "function"
          ? _c(
              "b-form-group",
              {
                staticClass: "mb-2",
                class: {
                  "error-input": _vm.$v.dataAutomation.function_name.$error
                }
              },
              [
                _c("label", [_vm._v(" Function Name ")]),
                _vm._v(" "),
                _c("j-input", {
                  attrs: {
                    "error-required":
                      _vm.$v.dataAutomation.function_name.$error,
                    "max-length": 255,
                    placeholder:
                      "Only lowercase characters and underscore '_' are allowed, ex: name_function"
                  },
                  model: {
                    value: _vm.$v.dataAutomation.function_name.$model,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.$v.dataAutomation.function_name,
                        "$model",
                        $$v
                      )
                    },
                    expression: "$v.dataAutomation.function_name.$model"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.dataAutomation.object === "job"
          ? _c(
              "b-form-group",
              {
                staticClass: "mb-2",
                class: { "error-input": _vm.$v.dataAutomation.job_name.$error }
              },
              [
                _c("label", [_vm._v(" Job Name ")]),
                _vm._v(" "),
                _c("j-input", {
                  attrs: {
                    "error-required": _vm.$v.dataAutomation.job_name.$error,
                    "max-length": 255,
                    placeholder:
                      "Only lowercase characters and underscore '_' are allowed, ex: name_job"
                  },
                  model: {
                    value: _vm.$v.dataAutomation.job_name.$model,
                    callback: function($$v) {
                      _vm.$set(_vm.$v.dataAutomation.job_name, "$model", $$v)
                    },
                    expression: "$v.dataAutomation.job_name.$model"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.dataAutomation.object === "dedicated_job"
          ? _c(
              "b-form-group",
              {
                staticClass: "mb-2",
                class: {
                  "error-input": _vm.$v.dataAutomation.dedicated_job_name.$error
                }
              },
              [
                _c("label", [_vm._v(" Dedicated Job Name ")]),
                _vm._v(" "),
                _c("j-input", {
                  attrs: {
                    "error-required":
                      _vm.$v.dataAutomation.dedicated_job_name.$error,
                    "max-length": 255,
                    placeholder:
                      "Only lowercase characters and underscore '_' are allowed, ex: name_dedicated_job"
                  },
                  model: {
                    value: _vm.$v.dataAutomation.dedicated_job_name.$model,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.$v.dataAutomation.dedicated_job_name,
                        "$model",
                        $$v
                      )
                    },
                    expression: "$v.dataAutomation.dedicated_job_name.$model"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.dataAutomation.object === "job" ||
        _vm.dataAutomation.object === "dedicated_job"
          ? _c(
              "div",
              { staticClass: "warning-function d-flex align-items-center" },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/icon/warning.svg"),
                    alt: "warning"
                  }
                }),
                _vm._v(" "),
                _vm._m(0)
              ]
            )
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "add-new-vp-footer" }, [
      _c(
        "button",
        { staticClass: "button-border mr-2", on: { click: _vm.closeModal } },
        [_vm._v("\n      Close\n    ")]
      ),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "button-blue", on: { click: _vm.submitData } },
        [_vm._v("\n      Create\n    ")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex flex-column" }, [
      _c("span", { staticClass: "title" }, [_vm._v("Information")]),
      _vm._v(" "),
      _c("span", [
        _vm._v("\n          Object Job will always be asynchronous\n        ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e84d4286", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e84d4286","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/visual-programming/popup/jPopupAddNew.vue
// module id = null
// module chunks = 